export enum ModelPurpose {
  SOURCE_ACCESS = "source_access",
  SOURCE_RECORD_EXTRACTION = "source_record_extraction",
  REVIEW_LABEL = "review_label",
  // WB-1571 (ADR-0102): pre-triage of one non-material Identity Review.
  IDENTITY_ADJUDICATION = "identity_adjudication",
  // ADR-0125: ranks one Company's rule-scored Spark candidates.
  SPARK_TRIAGE = "spark_triage",
  DETECTION_PROPOSAL = "detection_proposal",
  BRIEF = "brief",
  // Owner decision 6 (2026-10-13): the Company Profile's company type,
  // services and franchise, read from the Company's captured pages.
  WEBSITE_CLASSIFICATION = "website_classification",
  // ADR-0194 rule 5 (a model reads each new authority word once, and a meaning
  // holds only when independent readings agree): one reading of one word.
  WORD_READING = "word_reading",
  // The Digest Tuner's former draft reason for one File Change, which no code
  // calls now: the Digest lists the Score Inputs that moved each score, with
  // no model call (owner ruling, 2026-10-26). Stored Model Calls carry it, so
  // it stays, with its prompts in the registry.
  DIGEST = "digest",
}

export const dataByModelPurpose: Record<ModelPurpose, { label: string }> = {
  [ModelPurpose.SOURCE_ACCESS]: { label: "Source access" },
  [ModelPurpose.SOURCE_RECORD_EXTRACTION]: { label: "Record extraction" },
  [ModelPurpose.REVIEW_LABEL]: { label: "Review labels" },
  [ModelPurpose.IDENTITY_ADJUDICATION]: { label: "Identity adjudication" },
  [ModelPurpose.SPARK_TRIAGE]: { label: "Spark triage" },
  [ModelPurpose.DETECTION_PROPOSAL]: { label: "Detection proposals" },
  [ModelPurpose.BRIEF]: { label: "Brief" },
  [ModelPurpose.WEBSITE_CLASSIFICATION]: { label: "Website classification" },
  [ModelPurpose.WORD_READING]: { label: "Word reading" },
  [ModelPurpose.DIGEST]: { label: "Digest" },
}
